export default __webpack_public_path__ + "static/media/bg07.25ee478a.png";